import { httpInterceptor } from '../http-interceptor';

export class PlantService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllPlantsNew',
    SAVE_NEW: 'Machine/saveNewPlant',
    UPDATE: 'Machine/saveNewPlant',
    DELETE: 'Machine/deletePlant',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdatePlantMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByPlantId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getPlantMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/savePlantMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllPlantByAsstNo',
    GET_SAFETY_CHECKLIST_BY_PLANT: 'Machine/plantSafetyChecklistByPlant',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdatePlantSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deletePlantSafetyChecklist'
  };

  static async getAllPlants(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewPlant(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updatePlant(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deletePlant(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async savePlantMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByPlantId(plantId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${plantId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(maintenanceData) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, maintenanceData);
  }

  static async getAllPlantByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getPlantSafetyChecklistByPlant(plantId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_PLANT}/${plantId}`,
    );
  }

  static async createPlantSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deletePlantSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
